import { render, staticRenderFns } from "./navgate.vue?vue&type=template&id=1e6476c6"
import script from "./navgate.vue?vue&type=script&lang=js"
export * from "./navgate.vue?vue&type=script&lang=js"
import style0 from "./navgate.vue?vue&type=style&index=0&id=1e6476c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports